import {defineStore} from "pinia";

export const twoFactorStore = defineStore('twoFactor', {
  state: () => ({
    enable2fa: false,
    token2fa: '',
  }),
  getters:{
    getEnable2fa: (state) => state.enable2fa,
    getToken2fa: (state) => state.token2fa,
  },
  actions:{
    setEnable2fa(payload){
      this.enable2fa = payload;
    },
    setToken2fa(payload){
      this.token2fa = payload;
    }
  }
});
